exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.dmb-web__SplitViewButton__splitView__2RF5M {\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);\n          box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);\n  color: #555;\n  height: 36px;\n  padding: 0 13px;\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: 499;\n}\n\nbutton.dmb-web__SplitViewButton__splitView__2RF5M:hover {\n  background-color: #eee;\n  color: #555;\n}\n\nbutton.dmb-web__SplitViewButton__splitView__2RF5M:active {\n  background-color: #d5d5d5;\n}\n\nbutton.dmb-web__SplitViewButton__splitView__2RF5M svg {\n  font-size: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"splitView": "dmb-web__SplitViewButton__splitView__2RF5M"
};